import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_PRE_PROPOSAL,
  GET_PRE_PROPOSAL_BY_HASH,
  UPDATE_PRE_PROPOSAL,
  PENDING_PRE_PROPOSAL,
  APPROVE_PRE_PROPOSAL,
} from './actionType';

// common success
export const PreProposalApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const PreProposalApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const GetPreProposal = () => ({
  type: GET_PRE_PROPOSAL,
});

export const GetPreProposalByHash = (hash) => ({
  type: GET_PRE_PROPOSAL_BY_HASH,
  payload: { hash },
});

export const UpdatePreProposal = (hash, data) => ({
  type: UPDATE_PRE_PROPOSAL,
  payload: { hash, data },
});

export const PendingPreProposal = (hash, data) => ({
  type: PENDING_PRE_PROPOSAL,
  payload: { hash, data },
});

export const ApprovePreProposal = (hash, history) => ({
  type: APPROVE_PRE_PROPOSAL,
  payload: { hash, history },
});
